import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AdminPage from './pages/Admin';
import SignInPage from './pages/SignIn';
import CreateAccPage from './pages/CreateAcc.jsx';
import HomePage from './pages/Home.jsx';
import RecipePage from './pages/Recipe';
import UserManPage from './pages/UserMang.jsx';
import AnalyticsPage from './pages/Analytics.jsx';
import SearchResultsPage from './pages/SearchResult';
import ProfilePage from './pages/Profile';
import UserPage from './pages/User';
import AddRecipePage from './pages/AddRecipe';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<SignInPage />} />
        <Route path="/home" element={<HomePage />} />
        <Route path="/search" element={<SearchResultsPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/usermanagement" element={<UserManPage />} />
        <Route path="/analytics" element={<AnalyticsPage />} />
        <Route path="/createacc" element={<CreateAccPage />} />
        <Route path="/recipe/:id" element={<RecipePage />} />
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/user/:username" element={<UserPage />} />
        <Route path="/addrecipe" element={<AddRecipePage />} />
      </Routes>
    </Router>
  );
}

export default App;